import { createContext } from 'react';

export const U21FormContext = createContext({
  disabled: false,
  loading: false,
  preventEnterSubmit: false,
});
